import { postRequest } from "../../../services/RestServices";
import * as urls from "../../api/C4S Decommission - Replacement/url";

export const validateVinQty = async (data) => {
  try {
    return await postRequest(urls.VALIDATE_VIN_QTY, data);
  } catch (err) {
    return err;
  }
};
